export default {
  STD: "std",
  PRO: "pro",
  GPS: "gps"
};
